<template>
  <div class="container">
    <div class="content">
      <div class="item">来啦~世界上最好看的人儿</div>
      <div class="item1">我想看"<span class="item3">{{title}}</span>"这条干货呀,拜托帮我<span class="item3">助力一下</span>呗~</div>
      <div class="item1">(<span style="font-weight:600">长按关注这个公众号</span>即可)</div>
      <img class="share" :src="sharebgImg" alt="">
      <!-- <div class="user">
        <img class="user_icon" :src='userImg' alt="">
        <div class="user_right">
            <div class="font">我是'<span class="item4">除了学习啥也不相干的</span>'小姨妈</div>
            <div class="font">只输出'<span class="item4">说人话</span>'的求职干货</div>
        </div>
      </div> -->
      <!-- <div class="box">
        <div class="box_left">
          <h1 style="color:#B3212D;">职场小姨妈</h1>
          <div class="text">校招干货咨询</div>
          <div class="text2">&nbsp;&nbsp;&nbsp;&nbsp;简历||面试||职业规划</div>
          <div class="text">职场自我提升</div>
          <div class="text1">&nbsp;&nbsp;&nbsp;&nbsp;思维||沟通||认知提升</div>
        </div>
        <div class="box_right">
          <img class="code_icon" :src='codeImg' alt="">
        </div>
      </div> -->
       <div class="item2">拜托啦~</div>
    </div>
  </div>
</template>
<style scoped>
.container{
  overflow-y: scroll;
  /* font-family:Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei"; */
  background-color: #fff;
  color: rgb(34,34,34);
}

.content{
  width: 100%;
  background-color: #fff;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  padding-top: 50px;
}
.item{
  font-size: 17px;
  color: rgb(34,34,34);
  text-decoration:underline;
  line-height: 28px;
  margin-bottom: 5px;
  font-style: italic;
}
.item1{
  font-size: 17px;
  color: rgb(34,34,34);
  line-height: 28px;
  margin-top: 30px;
}
.item2{
  font-size: 17px;
  color: rgb(34,34,34);
  line-height: 28px;
  font-weight: 600;
  margin-top: 15px;
}
.share{
  width: 100%;
  height: auto;
  margin-top: 40px;
}
.item3{
  font-size: 17px;
  color:#B3212D;
}
.item4{
  font-size: 17px;
  color:#B3212D;
}
.user{
  width: 100%;
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.user_right{
  margin-left: 12px;
  justify-content: center;
  display: flex;
  flex-direction: column;
  line-height: 20px;
}
.user_icon{
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.font{
  font-size: 17px;
  color: rgb(34,34,34);
}
.box{
  width: 100%;
  border:1px solid #e7e7e7;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
    /* padding-left: 15px; */
    box-sizing: border-box;
    padding-bottom: 15px;
}
.box_left{
  
}
.text{
  font-size: 17px;
  color: rgb(34,34,34);
  line-height: 25px;
}
.text1{
  font-size: 17px;
  color: rgb(34,34,34);
  line-height: 28px;
  font-weight: 600;
}
.text2{
  font-size: 17px;
  color: rgb(34,34,34);
  line-height: 28px;
  font-weight: 600;
  border-bottom: 1px solid #e7e7e7;
}
.code_icon{
  width: 130px;
  height: 130px;
  margin-top: 7.5px;
}
</style>

<script>
import { getToken } from '../apollo/apollo'
import wx from 'weixin-js-sdk';


export default {
  components: {
    
  },
  data() {
    return {
      userImg:'./static/imgs/user.jpg',
      codeImg:'./static/imgs/code.jpg',
      sharebgImg:'./static/imgs/sharebg.png',
      user_id:'',
      article_id:'',
      area:'',
      url:'',
      title:'',
    }
  },
  computed:{
    
  },
  created() {
   this.initData()
  },
  mounted(){
 
  },
  methods: {
    //获取参数
      getQueryStringOne(name) {
            var url=JSON.stringify(window.location.href)
            // var url=JSON.stringify('https://screen.xiaoyima.work/index.html?user_id=2723&article_id=111#/share')
            url=url.replace('?','&')
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = url.substr(1).match(reg);
		    return r?unescape(decodeURIComponent(r[2])):null; 
        },

     initData() {
      this.title=this.getQueryStringOne('title')
      this.article_id=this.getQueryStringOne('article_id')*1
      this.user_id=this.getQueryStringOne('user_id')*1
      var code = this.getQueryVariable('code')
      sessionStorage.setItem('article_id',this.article_id)
      sessionStorage.setItem('user_id',this.user_id)
      sessionStorage.setItem('title',this.getQueryStringOne('title'))
      sessionStorage.setItem('share','1')
      this.area = 'snsapi_base';
      if(code){
         sessionStorage.setItem('share','')
          var formDate={
            code:code,
            area:this.area,
            user_id:this.user_id,
            article_id:this.article_id,
          }
          getToken(formDate).then(res=>{
            var login=JSON.parse(res.data.login)
            // sessionStorage.setItem('headimgurl',login.data.headimgurl)
            // sessionStorage.setItem('nickname',login.data.nickname)
            // sessionStorage.setItem('Authorization',login.data.Authorization);
            // this.jump('./share')
          })
            .catch(err=>{
              alert(err)
            })
      }else{
          var appid = 'wx1ebfca7e067859a6';
          var redirect_uri = encodeURI('https://screen.xiaoyima.work/index.html');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+appid+"&redirect_uri="+redirect_uri+"&response_type=code&scope="+this.area+"&state=123#wechat_redirect"
      }
    },
    getQueryVariable(variable)
    {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
        }
        return(false);
    }



  }, 
  destroyed () {  
      
    
  },
  watch:{
    
  }
};
</script>


// WEBPACK FOOTER //
// src/views/share.vue